import { render, staticRenderFns } from "./CmsMenuGroupForm.vue?vue&type=template&id=1ccbd110&"
import script from "./CmsMenuGroupForm.vue?vue&type=script&lang=js&"
export * from "./CmsMenuGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports